<template>
  <div class="form-group" :class="{ 'has-error': errors.has(fieldId) }">
    <label v-if="label">{{ label }}</label>
    <div :class="{'input-group': isGroupType}">
      <input type="number"
             :name="fieldId"
             :id="fieldId"
             maxlength="2"
             :value="value"
             @input="updateValue($event.target.value)"
             :min="min"
             :max="max"
             :step="step"
             class="form-control"
             :class="cssClass"
             :placeholder="placeholder"
             v-validate="validation"
             data-vv-value-path="value"
             data-vv-validate-on="input"/>
      <div class="input-group-addon" v-show="suffix">{{ suffix }}</div>
    </div>
    <p class="text-danger" v-if="errors.has(fieldId)">{{ errors.first(fieldId) }}</p>
  </div>
</template>
<script>

  export default {
    inject: ['$validator'],
    props: {
      value: {},
      label: {
        type: String,
        required: false
      },
      cssClass: {
        type: String,
        required: false
      },
      fieldId: {
        type: String,
        required: true
      },
      max: {
        type: Number,
        required: false
      },
      min: {
        type: Number,
        required: false
      },
      step: {
        type: Number,
        required: false,
        default() {
          return 1;
        }
      },
      placeholder: {
        type: String
      },
      suffix: {
        type: String
      },
      validation: {
        type: String
      },
      required: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      isGroupType() { return !!this.suffix; }
    },
    methods: {
      updateValue(value) {
        this.$emit('input', value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/form/numberField.vue